






import Vue from "vue";
import ContactInfoDisplay from "@/components/deployment/ContactInfoDisplay.vue";
export default Vue.extend( {
  components: {
    ContactInfoDisplay
  }
});
